import { TypeTherapyScreenerV2, TypeTherapyScreenerV2Fields } from 'types/contentful';
import ContentService, { CONTENTFUL_LOCALE_MAP } from 'utils/contentful/contentfulService';

export const getScreenerForAge = async (ageInMonths: number, locale?: string): Promise<TypeTherapyScreenerV2> => {
  return ContentService.clients.expressable
    .getEntries<TypeTherapyScreenerV2Fields>({
      content_type: 'therapyScreenerV2',
      'fields.minimumAgeMonths[lte]': ageInMonths,
      'fields.maximumAgeMonths[gte]': ageInMonths,
      locale: locale ? CONTENTFUL_LOCALE_MAP[locale] : undefined,
    })
    .then(result => result.items)
    .then(items => {
      if (items.length === 0) {
        throw new Error(`No screener found for the given age of ${ageInMonths} months`);
      } else {
        return items[0] as TypeTherapyScreenerV2;
      }
    })
    .then(screener => {
      const filteredQuestions = screener.fields.questions.filter(
        ({ fields: { maximumAgeMonths, minimumAgeMonths } }) => {
          return (
            (!maximumAgeMonths || maximumAgeMonths >= ageInMonths) &&
            (!minimumAgeMonths || minimumAgeMonths <= ageInMonths)
          );
        },
      );

      return {
        ...screener,
        fields: {
          ...screener.fields,
          questions: filteredQuestions,
        },
      } as TypeTherapyScreenerV2;
    });
};
